module.exports = __webpack_public_path__ + "assets/img/btn-view-all-5183a3bf.png";